import React, { useEffect, useState } from "react";
import { HeaderHLPure, PromotionalFooterPure, SimpleLoading, DialogSystemGLPure } from "../../pures";
import ProcedureAdministrationPrincipalView from "./procedure-administration-principal.view";
import ProcedureAdministrationConfiguration from "./procedure-administration-configuration";
import { Container, Grid } from '@material-ui/core'
import { useTranslation } from "react-i18next"
import './procedure-administration.css'

const ProcedureAdministrationView = (props) => {
    let {
        isLoadingView,
        showLoadingRequesting,
        toggleLoadingRequesting,
        showCompletedRequesting,
        toggleCompletedRequesting,
        showErrorRequesting,
        toggleErrorRequesting,
        messageError,
    } = props

    const { t } = useTranslation()

    const [showPrincipalView, setShowPrincipalView] = useState(true)
    const [headerTitle, setHeaderTitle] = useState(t("procedureAdministrationView.title.header.principal"))
    const [procedureSelectedGrid, setProcedureSelectedGrid] = useState({})
    const [viewSelected, setViewSelected] = useState('')
    const [showDetails, setShowDetails] = useState(false)

    useEffect(() => {  
        if(!viewSelected) return 
        handleShowOtherView()
    }, [viewSelected])

    const handleShowOtherView = () => {
        switch (viewSelected) {
            case t("procedureAdministrationView.details"):
                setHeaderTitle(t("procedureAdministrationView.title.header.edit"))
                break;
            case t("procedureAdministrationView.new.prodecure"):
                setHeaderTitle(t("procedureAdministrationView.title.header.new"))
                break;
        
            default:
                setHeaderTitle(t("procedureAdministrationView.title.header.principal"))
                break;
        }
        setShowPrincipalView(false)

    }

    const handleShowPrincipalView = () => {
        setHeaderTitle(t("procedureAdministrationView.title.header.principal"))
        setShowPrincipalView(true)
        setViewSelected('')
    }
    
    if (isLoadingView) return <SimpleLoading />

    return(
        <div  className="procedureAdministrationView-wrapper">
            <Container>
                <Grid container spacing={2}>
                    <div className="procedureAdministrationView-header">
                        <HeaderHLPure title={headerTitle} />
                    </div>
                    <div className="procedureAdministrationView-body">
                        {
                            showPrincipalView ? (
                                <ProcedureAdministrationPrincipalView
                                    {...props}
                                    t={t}
                                    setProcedureSelectedGrid={setProcedureSelectedGrid}
                                    setShowDetails={setShowDetails}
                                    setViewSelected={setViewSelected}
                                    procedureSelectedGrid={procedureSelectedGrid}
                                />
                            ) : (
                                <ProcedureAdministrationConfiguration
                                    {...props} 
                                    t={t}
                                    showPrincipalView={showPrincipalView}
                                    viewSelected={viewSelected}
                                    procedureSelectedGrid={procedureSelectedGrid}
                                    handleShowPrincipalView={handleShowPrincipalView}
                                />
                            )
                        }
                    </div>
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                        <PromotionalFooterPure />
                    </Grid>
                    <DialogSystemGLPure
                        showLoadingRequesting={showLoadingRequesting}
                        toggleLoadingRequesting={toggleLoadingRequesting}

                        showCompletedRequesting={showCompletedRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}

                        showErrorRequesting={showErrorRequesting}
                        toggleErrorRequesting={toggleErrorRequesting}
                        messageError={messageError} 
                    />
                </Grid>
            </Container>
        </div>
    )
}

export { ProcedureAdministrationView as default}